import React, {Component } from 'react';
import { observer } from 'mobx-react';
import Modal from 'react-bootstrap/Modal';
import { Button} from 'react-bootstrap';

import imageURLs from '../../sharedFiles/ImagesURLs';

const ErrorMessageComponent = observer(class ErrorMessageComponent extends Component {

	constructor (props) {
        super(props);
    }
	componentWillMount(){

	}


	render(){
		const {show, 
			   store,
				title,
				callBack,
				body_html,
				cancel_btn,
				save_btn,
				appStore,
				singleButton,
				logoutCss,
			    closeButtonRequired} = this.props;
		return (
			<Modal backdrop='static'  className={(appStore ? appStore.selectedColor.value : '')+" "+(logoutCss ? logoutCss:"")} show = {show} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => closeButtonRequired ? appStore.logout(): this.props.closePopup() }>
				  <Modal.Header style={{width: "300px",height: "auto"}}  closeButton >
				    <Modal.Title  dangerouslySetInnerHTML={{__html: title}}></Modal.Title>
				  </Modal.Header>

				  <Modal.Body dangerouslySetInnerHTML={{__html: body_html}}>
				    
				  </Modal.Body>

				  <Modal.Footer>
				    <Button className="btn_cancel" type="button" variant="secondary" onClick={() => this.props.closePopup()} >{appStore.getLanguageTrans(cancel_btn)}</Button>				  
				  </Modal.Footer>                      
				</Modal>
		)
	}
})
export default ErrorMessageComponent;
